// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"file-uploader_disable-scroll__2Rfjm"};